module.exports = __webpack_public_path__ + "static/media/silkycloud-pink-5.7e19a669.png";